import type { ColumnDef } from "@tanstack/react-table"

import { AgentStateBadge } from "@/components/agents/agent-state-badge"
import TextLink from "@/components/text-link"
import { adminAccountPath, adminAgentPath } from "@/routes"
import type { Agent } from "@/types"

export const columns: ColumnDef<Agent>[] = [
  {
    accessorKey: "name",
    enableSorting: true,
    header: "Name",
    cell: ({ row }) => {
      return (
        <TextLink href={adminAgentPath(row.original.uid)} as="div" prefetch>
          {row.original.name}
        </TextLink>
      )
    },
  },
  {
    accessorKey: "account_uid",
    header: "Account",
    cell: ({ row }) =>
      row.original.account?.uid ? (
        <TextLink
          href={adminAccountPath(row.original.account?.uid)}
          as="div"
          prefetch
        >
          {row.original.account?.name}
        </TextLink>
      ) : null,
  },
  {
    accessorKey: "last_execution_at",
    enableSorting: true,
    header: "Last execution",
    cell: ({ row }) =>
      row.original.last_execution_at
        ? new Date(row.original.last_execution_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "-",
  },
  {
    accessorKey: "created_at",
    enableSorting: true,
    header: "Created",
    cell: ({ row }) =>
      new Date(row.original.created_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      }),
  },
  {
    accessorKey: "state",
    enableSorting: true,
    header: "Status",
    cell: ({ row }) => <AgentStateBadge state={row.original.state} />,
  },
]
